import { render, staticRenderFns } from "./BackBar.vue?vue&type=template&id=2b4390fa"
import script from "./BackBar.vue?vue&type=script&lang=js"
export * from "./BackBar.vue?vue&type=script&lang=js"
import style0 from "./BackBar.vue?vue&type=style&index=0&id=2b4390fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports